import {
  isValidEmail,
  isValidNumber,
  isValidPhone,
  isValidUrl
} from '@elfsight/lib-utils';

export const fieldValidators = {
  email: isValidEmail,
  URL: isValidUrl,
  phone: isValidPhone,
  number: isValidNumber
} as const;
